const DATA_LOGGER = 'DATA_LOGGER'
const ZEUSINT = 'ZEUSINT'
const GOLDCARD = 'GOLDCARD'

const PROVIDERS = [DATA_LOGGER, ZEUSINT, GOLDCARD]

const providers = {
    DATA_LOGGER,
    ZEUSINT,
    GOLDCARD,
    PROVIDERS,
}
export default providers
